interface ShortlistPageTitleParams {
  jobTitle: string;
  location?: string;
}

export function formatShortlistPageTitle({
  jobTitle,
  location,
}: ShortlistPageTitleParams) {
  const trimmedLocation = location?.trim();

  if (!trimmedLocation) {
    return jobTitle;
  }

  return `${jobTitle}, ${trimmedLocation}`;
}

export function formatShortlistPageMetaSuffix({ count }: { count: number }) {
  const candidateLabel = count === 1 ? 'candidate' : 'candidates';

  return `${count} qualified ${candidateLabel} found · ranked by fit`;
}

export const SHORTLIST_OG_DESCRIPTION =
  'Review ranked, qualified candidates curated for your open role on Finlay.';

interface ShortlistOgTitleParams {
  companyName: string;
  jobTitle: string;
}

export function formatShortlistOgTitle({
  companyName,
  jobTitle,
}: ShortlistOgTitleParams) {
  return `${jobTitle} candidates for ${companyName}`;
}

interface ShortlistCandidateOgTitleParams {
  companyName: string;
  fullName: string;
  jobTitle: string;
}

export function formatShortlistCandidateOgTitle({
  companyName,
  fullName,
  jobTitle,
}: ShortlistCandidateOgTitleParams) {
  return `${fullName} · ${jobTitle} at ${companyName}`;
}
